<template>
    <div class="product" :data-upc="product_upc" v-if="api_request_resolved && !product_discontinued">
        <div class="product__out-of-stock" v-if="!product_can_be_ordered">Out of Stock</div>

        <div class="product__image-wrapper">
            <img class="product__image" :src="product_image_url"
                 @load="image_loaded = true" :class="{ loaded: image_loaded }"
            >
        </div>

        <div class="product__details">
            <h3 class="product__title">{{ product_name }}</h3>
            <div class="product__price">${{ price }}</div>
        </div>

        <button @click="addToBag" class="product__cta">{{ cta_text }}</button>
    </div>
</template>

<script>
import { isString } from '../utilities'
import { analytics, shopping, product, user } from 'shiseido-apis'

export default {
    props: {
        product: {
            default() {
                return {
                    upc: '',
                    name: '',
                }
            },
            validate(obj) {
                return ['upc', 'name'].map((prop) => obj.hasOwnProperty(prop))
            },
            type: Object,
        },
    },
    data() {
        return {
            api_request_resolved: false,
            product_discontinued: true,
            product_can_be_ordered: false,
            product_name: '',
            price: 0,
            long_description: '',
            product_upc: this.product.upc,
            product_image_url: '',
            image_loaded: false,
        }
    },
    computed: {
        description() {
            return this.short_description || this.long_description
        },
        cta_text() {
            return this.product_can_be_ordered
                ? 'ADD TO BAG'
                : 'ADD TO WISHLIST'
        },
    },
    created() {
        this.fetchData()
    },
    methods: {
        fetchData() {
            product.getShiseidoProductDetails(this.product_upc)
                .then((response) => {
                    const {
                        name,
                        price,
                        c_discontinued,
                        image_groups = [],
                        inventory,
                        short_description,
                        long_description,
                        fault,
                    } = response

                    this.product_discontinued = c_discontinued

                    if (!fault && !this.product_discontinued) {
                        const hi_res_images = image_groups.filter(({ view_type }) => view_type === 'hi-res')

                        this.product_name = name
                        this.price = isString(price) ? price : price.toFixed(2)
                        this.product_can_be_ordered = inventory.orderable
                        this.short_description = short_description
                        this.long_description = long_description

                        const [upc_to_match] = this.product_upc.match(/(?!0)[0-9]{12}/)
                        const matching_upc = ({ dis_base_link }) => dis_base_link.match(upc_to_match)

                        if (hi_res_images.length > 1) {
                            const product_images = hi_res_images.filter(({ images: i }) => i.some(matching_upc))

                            if (product_images.length > 0) {
                                const [image] = product_images[0].images.filter(matching_upc)
                                this.product_image_url = image.dis_base_link.concat('?sh=240&sw=184')
                            }
                        } else {
                            const [image] = hi_res_images[0].images
                            this.product_image_url = image.dis_base_link.concat('?sh=240&sw=184')
                        }
                    }

                    this.api_request_resolved = true
                })
        },
        addToBag() {
            if (this.product_can_be_ordered) {
                shopping.addToCart(this.product_upc)
            } else {
                if (!user.loggedIn()) {
                    const pathname = this.$route.path.replace(/\s/g, '%20')

                    window.history.pushState({}, '', `${ window.location.origin }?hashpath=${ pathname }/#${ pathname }`)
                }

                shopping.addToWishlist(this.product_upc)
            }

            analytics.registerClick({
                element: 'Add To Bag',
                toolname: 'Gift Guide',
                question: 'Results',
                answers: [],
            })
        },
        retryImage() {
            this.product_image_url = this.product_image_url.replace(/[0-9]{13}/, (upc) => upc.substring(1))
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/js/app/components/product.vue